export enum ReferredUserStatus {
  SignedUp = "signed-up",
  Purchased = "purchased",
}
